import { render } from "./NewNotes.vue?vue&type=template&id=3cc1bb4e&scoped=true&bindings={\"lan\":\"options\"}"
import script from "./NewNotes.vue?vue&type=script&lang=js"
export * from "./NewNotes.vue?vue&type=script&lang=js"

import "./NewNotes.vue?vue&type=style&index=0&id=3cc1bb4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3cc1bb4e"

export default script